var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-none d-md-block" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.quizData.showStepTitle,
            expression: "quizData.showStepTitle",
          },
        ],
        staticClass: "row",
      },
      [
        _c(
          "ul",
          {
            staticClass: "quizTopCTAs ti-scrollbar",
            class: [this.lightTheme ? "light" : ""],
          },
          [
            _vm._l(this.stepData.titles, function (item) {
              return _c("li", { key: item.id }, [
                _c(
                  "button",
                  {
                    class: [
                      item.id,
                      "stepIndicator ti-fs-16",
                      !_vm.isResultsPage && item.current ? "active" : "",
                      item.answered ? "answered" : "unanswered",
                      !_vm.quizData.navBtns && item.answered
                        ? "answereddisabled"
                        : "",
                    ],
                    attrs: {
                      "aria-disabled": !_vm.isResultsPage && !item.answered,
                      "aria-current":
                        !_vm.isResultsPage && item.current ? "step" : "false",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.gotoQuestion(
                          item.id,
                          item.current,
                          item.answered,
                          _vm.isResultsPage
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.isResultsPage && item.answersTitles[0]
                            ? item.answersTitles[0]
                            : item.title
                        ) +
                        "\n                "
                    ),
                  ]
                ),
              ])
            }),
            _vm._v(" "),
            _c(
              "li",
              {
                class: [
                  "stepIndicator ti-fs-16",
                  _vm.isResultsPage ? "active" : "",
                ],
                attrs: { disabled: !_vm.isResultsPage },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.stepSelectionText) +
                    "\n            "
                ),
              ]
            ),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    !_vm.isResultsPage && _vm.question.skippable
      ? _c(
          "button",
          {
            staticClass:
              "stepbarcomponent-skipbutton ti-btn ti-btn-pill ti-text-color-black",
            on: {
              click: function ($event) {
                return _vm.skipQuestion()
              },
            },
          },
          [_vm._v("\n        " + _vm._s(_vm.skipQuestionText) + "\n    ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }